import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import { useState } from 'react';
import FeedbackButton from '@helsenorge/core-cms/feedbackbutton';
import FeedbackPanel from '@helsenorge/core-cms/feedbackpanel';
import styles from './feedbackpanel-wrapper.module.scss';
const FeedbackPanelWrapper = props => {
    const [isVisible, setIsVisible] = useState(true);
    const handleClose = (id) => {
        setIsVisible(false);
        props.onClose(id);
    };
    if (!isVisible) {
        return null;
    }
    return (_jsxs(FeedbackPanel, { title: props.survey.title, variant: props.variant, closeButtonText: props.survey.closeButtonText, onClose: () => handleClose(props.survey.id), buttons: _jsxs(_Fragment, { children: [_jsx(FeedbackButton, { variant: "outline", onClick: () => handleClose(props.survey.id), href: props.survey.surveyUrl, htmlMarkup: "a", children: props.survey.acceptButtonText }), _jsx(FeedbackButton, { variant: "borderless", onClick: () => handleClose(props.survey.id), children: props.survey.declineButtonText })] }), children: [props.survey.text, props.survey.disclaimerText && (_jsx("p", { className: styles.disclaimertext, children: props.survey.disclaimerText.replace('{url}', props.survey.surveyUrl) }))] }));
};
export default FeedbackPanelWrapper;
